<template>
  <div class="login-container">

    <!-- 右侧登录表单 -->
    <div class="right-login">
      <div class="login-card">
        <!-- 登录方式标签页 -->
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: activeTab === 'account' }"
            @click="activeTab = 'account'"
          >
            账号登录
          </div>
          <div
            class="tab-item"
            :class="{ active: activeTab === 'phone' }"
            @click="activeTab = 'phone'"
          >
            手机登录
          </div>
        </div>

        <!-- 账号登录表单 -->
        <el-form
          v-if="activeTab === 'account'"
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
        >
          <el-form-item prop="username">
            <div class="input-wrapper">
              <img
                src="@/assets/image/zh1.png"
                class="input-icon"
                alt="账号图标"
              >
              <el-input
                ref="username"
                v-model="loginForm.username"
                placeholder="请输入你的账号"
                name="username"
                type="text"
                tabindex="1"
                auto-complete="on"
              />
            </div>
          </el-form-item>

          <el-form-item prop="password">
            <div class="input-wrapper">
              <img
                src="@/assets/image/psw1.png"
                class="input-icon"
                alt="密码图标"
              >
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                :type="passwordType"
                placeholder="请输入密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                @keyup.enter.native="handleLogin"
              />
              <span
                class="show-pwd"
                @click="showPwd"
              >
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </div>
          </el-form-item>

          <el-form-item prop="captcha">
            <div class="input-wrapper captcha-row">
              <el-input
                v-model="loginForm.captcha"
                placeholder="请输入图形验证码"
                name="captcha"
                tabindex="3"
                auto-complete="off"
                class="captcha-input"
                @keyup.enter.native="handleLogin"
              />
              <img
                class="captcha-img"
                :src="captchaUrl"
                alt="图形验证码"
                @click="refreshCaptcha"
              >
            </div>
          </el-form-item>

          <div class="form-links">
            <el-dropdown
              trigger="click"
              @command="handleRegisterSelect"
            >
              <span class="link-item dropdown-trigger">
                注册
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown" class="register-dropdown">
                <el-dropdown-item command="user">用户注册</el-dropdown-item>
                <el-dropdown-item command="engineer">造价师注册</el-dropdown-item>
                <el-dropdown-item command="supplier">供应商注册</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="link-item" @click="goToForget">忘记密码</span>
          </div>

          <register-agreement ref="accountAgreement" />
          <el-button
            :loading="loading"
            type="primary"
            class="login-btn"
            @click.native.prevent="handleLogin"
          >
            登录
          </el-button>
        </el-form>

        <!-- 手机登录表单 -->
        <el-form
          v-if="activeTab === 'phone'"
          ref="phoneForm"
          :model="phoneForm"
          :rules="phoneRules"
          class="login-form"
        >
          <el-form-item prop="phone">
            <div class="input-wrapper">
              <img
                src="@/assets/image/sjh1.png"
                class="input-icon"
                alt="手机图标"
              >
              <el-input
                v-model="phoneForm.phone"
                placeholder="请输入手机号"
                name="phone"
                type="text"
                tabindex="1"
                auto-complete="on"
              />
            </div>
          </el-form-item>

          <el-form-item prop="code">
            <div class="input-wrapper">
              <img
                src="@/assets/image/code1.png"
                class="input-icon"
                alt="验证码图标"
              >
              <el-input
                v-model="phoneForm.code"
                placeholder="请输入验证码"
                name="code"
                type="text"
                tabindex="2"
                auto-complete="off"
                class="code-input"
              />
              <el-button
                type="text"
                size="small"
                class="code-btn"
                :disabled="codeCountdown > 0"
                @click="sendCode"
              >
                {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
              </el-button>
            </div>
          </el-form-item>

          <div class="form-links">
            <el-dropdown
              trigger="click"
              @command="handleRegisterSelect"
            >
              <span class="link-item dropdown-trigger">
                注册
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown" class="register-dropdown">
                <el-dropdown-item command="user">用户注册</el-dropdown-item>
                <el-dropdown-item command="engineer">造价师注册</el-dropdown-item>
                <el-dropdown-item command="supplier">供应商注册</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="link-item" @click="goToForget">忘记密码</span>
          </div>

          <register-agreement ref="phoneAgreement" />
          <el-button
            :loading="loading"
            type="primary"
            class="login-btn"
            @click.native.prevent="handlePhoneLogin"
          >
            登录
          </el-button>
        </el-form>

        <!-- 社交登录区域（共用） -->
        <div class="divider">
          <span class="divider-text">其他登录方式</span>
        </div>

        <div class="social-login">
          <div class="social-item">
            <img
              src="@/assets/image/wx1.png"
              alt="微信登录"
            >
          </div>
          <!-- <div class="social-item">
            <img
              src="@/assets/image/qq1.png"
              alt="QQ登录"
            >
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { accountLogin, sendLoginSmsCode, mobileLogin } from '@/api/user'
import { setToken, setUserInfo } from '@/utils/auth'
import RegisterAgreement from '@/components/RegisterAgreement.vue'

export default {
  name: 'Login',
  components: { RegisterAgreement },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (!value || value.trim() === '') callback(new Error('请输入图形验证码'))
      else callback()
    }
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位验证码'))
      } else {
        callback()
      }
    }
    return {
      activeTab: 'account',
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      phoneForm: {
        phone: '',
        code: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCaptcha }]
      },
      phoneRules: {
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }]
      },
      loading: false,
      passwordType: 'password',
      codeCountdown: 0,
      captchaUrl: '',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    redirectAndRefresh() {
      const targetPath = this.redirect || '/'
      // 先回到目标路由，再强制刷新一次，确保鉴权后的页面数据重新拉取
      this.$router.replace({ path: targetPath }).then(() => {
        this.$nextTick(() => {
          window.location.reload()
        })
      }).catch(() => {
        // replace 失败时兜底：直接刷新当前地址
        window.location.reload()
      })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    checkAgreement(refName) {
      const ref = this.$refs[refName]
      return !ref || ref.validate()
    },
    handleLogin() {
      if (!this.checkAgreement('accountAgreement')) return
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用账号密码登录API
          const data = {
            account: this.loginForm.username,
            password: this.loginForm.password,
            captcha: this.loginForm.captcha
          }
          accountLogin(data).then(response => {
            this.loading = false
            if (response.code === 1) {
              // 登录成功，缓存token和用户信息
              const aaa = response.data
              setToken(aaa.userinfo.token)
              setUserInfo(aaa.userinfo)
              this.$message.success('登录成功')
              this.redirectAndRefresh()
            }
            // 其他响应码（如203）已在响应拦截器中处理并显示错误提示
          }).catch(error => {
            this.loading = false
            console.error('登录失败:', error)
            // 错误提示已在响应拦截器中统一处理，这里不再重复显示
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    refreshCaptcha() {
      const t = Date.now()
      this.captchaUrl = `/api/user/captcha?t=${t}`
    },
    handlePhoneLogin() {
      if (!this.checkAgreement('phoneAgreement')) return
      this.$refs.phoneForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用手机号登录API
          const data = {
            mobile: this.phoneForm.phone,
            captcha: this.phoneForm.code
          }
          mobileLogin(data).then(response => {
            this.loading = false
            // 检查响应状态码
            if (response.code === 1) {
              // 登录成功，缓存token和用户信息
              const aaa = response.data
              setToken(aaa.userinfo.token)
              setUserInfo(aaa.userinfo)
              this.$message.success('登录成功')
              this.redirectAndRefresh()
            }
            // 其他响应码（如203）已在响应拦截器中处理并显示错误提示
          }).catch(error => {
            this.loading = false
            console.error('登录失败:', error)
            // 错误提示已在响应拦截器中统一处理，这里不再重复显示
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCode() {
      if (this.codeCountdown > 0) return

      this.$refs.phoneForm.validateField('phone', (errorMessage) => {
        if (errorMessage) {
          this.$message.error(errorMessage)
          return
        }

        // 调用发送登录验证码API
        const data = {
          mobile: this.phoneForm.phone,
          event: 'login'
        }

        sendLoginSmsCode(data).then(response => {
          // 开始倒计时
          this.codeCountdown = 60
          const timer = setInterval(() => {
            this.codeCountdown--
            if (this.codeCountdown <= 0) {
              clearInterval(timer)
            }
          }, 1000)

          this.$message.success('验证码已发送')
        }).catch(error => {
          console.error('发送验证码失败:', error)
        })
      })
    },
    goToForget() {
      this.$router.push('/forget')
    },
    goToRegister() {
      // 跳转到用户注册页面，用户可以选择其他注册类型
      this.$router.push('/register/user')
    },
    handleRegisterSelect(command) {
      // 根据选择的注册类型跳转到对应页面
      const routeMap = {
        user: '/register/user',
        engineer: '/register/engineer',
        supplier: '/register/supplier'
      }
      if (routeMap[command]) {
        this.$router.push(routeMap[command])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg1.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  // 右侧登录区域
  .right-login {
    position: absolute;
    right: 10%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

           .login-card {
         background: rgba(255, 255, 255, 0.95);
         backdrop-filter: blur(10px);
         border-radius: 20px;
         padding: 40px;
         width: 480px;
         box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
         border: 1px solid rgba(255, 255, 255, 0.2);

      .login-tabs {
        display: flex;
        margin-bottom: 30px;

        .tab-item {
          flex: 1;
          text-align: center;
          padding: 15px 0;
          font-size: 16px;
          color: #999;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;

          &.active {
            color: #111111;
            font-weight: 600;

            &::after {
              content: '';
              position: absolute;
              bottom: -2px;
              left: 50%;
              transform: translateX(-50%);
              width: 60%;
              height: 2px;
              background: #0f6fe2;
              border-radius: 1px;
            }
          }

          &:hover {
            color: #4a90e2;
          }
        }
      }

      .login-form {
        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 0 15px;
          background: #fff;
          transition: all 0.3s ease;

          &:focus-within {
            border-color: #4a90e2;
            box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
          }

          .input-icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            flex-shrink: 0;
          }

          .el-input {
            flex: 1;

            ::v-deep .el-input__inner {
              border: none;
              background: transparent;
              padding: 15px 0;
              font-size: 14px;
              color: #333;

              &::placeholder {
                color: #999;
              }
            }
          }

          &.captcha-row {
            gap: 12px;

            .captcha-input {
              flex: 1;
            }

            .captcha-img {
              width: 96px;
              height: 34px;
              border-radius: 6px;
              border: 1px solid #e0e0e0;
              cursor: pointer;
              object-fit: cover;
              flex-shrink: 0;
            }
          }

          .show-pwd {
            cursor: pointer;
            color: #999;
            margin-left: 10px;
            padding: 5px;
            border-radius: 4px;
            transition: all 0.3s ease;

            &:hover {
              color: #4a90e2;
              background: rgba(74, 144, 226, 0.1);
            }
          }

          &.code-input {
            .code-btn {
              margin-left: 10px;
              height: 36px;
              border-radius: 6px;
              font-size: 12px;
              color: #0f6fe2;
              font-weight: bold;
              background: transparent;
              border: none;
              padding: 0;

              &:hover {
                color: #0f6fe2;
                background: transparent;
              }

              &:disabled {
                color: #999;
              }
            }
          }
        }

        .form-links {
          display: flex;
          justify-content: space-between;
          margin: 20px 0;

          .dropdown-trigger {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 4px;
          }

          .link-item {
            color: #111111;
            cursor: pointer;
            font-size: 14px;
            transition: all 0.3s ease;

            &:hover {
              color: #111111;
              text-decoration: underline;
            }
          }
        }

        .login-btn {
          width: 100%;
          height: 48px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          background: linear-gradient(90deg, #0f6fe2, #0c89f2);
          border: none;
          margin-bottom: 30px;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
          }
        }
      }
    }
  }
}

.divider {
  text-align: center;
  margin: 30px 0;
  position: relative;

  .divider-text {
    background: #fff;
    padding: 0 20px;
    color: #999;
    font-size: 12px;
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0e0e0;
    z-index: 0;
  }
}
.social-login {
  display: flex;
  justify-content: center;
  gap: 30px;

  .social-item {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      border-color: #357abd;
      transform: scale(1.1);
    }

    img {
      width: 50px;
      height: 50px;
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .login-container {
    .right-login {
      right: 5%;

      .login-card {
        width: 380px;
        padding: 30px;
      }
    }
  }
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    padding: 20px;

    .right-login {
      position: relative;
      right: auto;
      top: auto;
      transform: none;

      .login-card {
        width: 100%;
        max-width: 400px;
        padding: 25px;
      }
    }
  }
}

// 注册下拉菜单样式
::v-deep .register-dropdown {
  .el-dropdown-menu__item {
    padding: 12px 20px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #f0f8ff;
      color: #0f6fe2;
    }
  }
}
</style>
